import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('old.components.DropdownEditor', {
    defaultPlaceholder: 'Enter text...',
    defaultEmptyListPlaceholder: 'Empty',
    defaultEmptyAddNew: 'Add...',
    defaultAddNew: 'Add {text}...',
    suggestedItemText: 'Suggested',
});
